module.exports = __webpack_public_path__ + "static/media/schools_banner.da5e4942.webp";